var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<flash-message></flash-message><div class=\"content\"><div class=\"profile-content prof-container password active\"><h2>Change Password</h2><password-change-form></password-change-form></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/settings/password/password.jade
// module id = 785
// module chunks = 0